export const CREATED = 'created';
export const AUTHORIZED = 'authorized';
export const CAPTURED = 'captured';
export const HOLDOUT = 'holdout';
export const FAILED = 'failed';



// WEBPACK FOOTER //
// ./src/lib/contribution-statuses.js